<template>
  <div :class="{ 'text-center': thisIsAmerica && isAVRMobile }">
    <h4>{{ $t('message.trade.estimatedTradeValue') }}</h4>
    <p class="mt-4 p-small text-muted d-none d-sm-block">
      {{ $t('message.trade.subNotes') }}
    </p>
    <div v-if="!thisIsAmerica">
      <h1 data-cy="estimatedTradeValue" class="blue">
        {{ $n(total, 'currencyDollars', languageCode) }}
      </h1>
      <MobialisHorizontalRule width="40" class="ml-0 mb-4" />
      <span class="average-value font-weight-bold mb-3">{{ $n(price, 'currencyDollars', languageCode) }}</span>
      <span class="average-text">{{ $t('message.trade.avgPrice') }}</span>
      <br />
      <span class="average-value font-weight-bold">+ {{ $n(taxSavings, 'currencyDollars', languageCode) }}</span>
      <span class="average-text">{{ $t('message.trade.avgTaxSavings') }}</span>
      <p class="mt-4 p-small d-block d-sm-none">
        {{ $t('message.trade.subNotes') }}
      </p>
      <p class="p-xsmall text-muted">{{ taxInfoText }}</p>
    </div>
    <div v-else>
      <div class="price-container" data-cy="estimatedTradeValue">
        {{ $n(price, 'currencyDollars', languageCode) }}
      </div>
      <p class="mt-4 p-small d-block d-sm-none">
        {{ $t('message.trade.subNotes') }}
      </p>
    </div>
    <slot name="bottomSlot"></slot>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'EstimatedValue',
  data() {
    return {
      taxInfoText: `*${this.$store.state.trade.tradein.tax_rate}% ${this.$t(
        'message.trade.TotalTradeInValue.taxInfo'
      )}`,
    };
  },
  props: {
    price: {
      type: Number,
      default: 999999.0,
      validator: num => !Number.isNaN(num) && num > 0,
      required: true,
    },
    taxSavings: {
      type: Number,
      default: 999999,
      validator: num => !Number.isNaN(num),
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      languageCode: 'user/getLanguageCodeForNumericalInternationalization',
      thisIsAmerica: 'business/getThisIsAmerica',
    }),
    total() {
      return this.price + this.taxSavings;
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'src/assets/scss/variables';
h1 {
  font-size: 36px;
}
.average-value {
  margin-right: 10px;
  margin-bottom: 10px;
}
.average-text {
  font-size: 16px;
  font-weight: normal;
  color: #4b5863;

  @media (min-width: 576px) {
    font-size: 14px;
  }
}
.blue {
  color: $primary;
  margin-bottom: 24px;
}
.poweredby {
  font-size: 12px;
  font-weight: normal;

  img {
    margin-left: 5px;
    width: 79px;
  }
}

.price-container {
  background: rgb(240, 240, 240);
  border-radius: 6px;
  padding: 60px 0;
  width: 310px;
  margin: 40px auto;
  color: $primary;
  font-size: 36px;
  line-height: 35px;
  font-weight: bold;
  text-align: center;
  @media (max-width: 500px) {
    width: 275px;
    padding: 40px 0;
  }
}
</style>
